export enum StagesEnum
{
    DIAGONSES = 1,
    TREAT_FIRST_STAGE = 2,
    DIAGONSES_AFTER_TREATMENT = 3,
    TREATMENT_SECOND_STAGE = 4,
    DIAGONSES_LAST = 5
}
